import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    status: "idle",
    pendingResume: false,
    activeLabel: null,
    waitingSince: null,
};
const recordingSlice = createSlice({
    name: "recording",
    initialState,
    reducers: {
        /*startRecording: (state, action: PayloadAction<string>) => {
          state.status = "recording";
          state.activeLabel = action.payload;
          state.pendingResume = false;
          state.waitingSince = null;
        },
    
        stopRecording: (state) => {
          state.status = "idle";
          state.pendingResume = false;
          state.activeLabel = null;
          state.waitingSince = null;
        },
    
        beginViewSwitch: (state) => {
          state.status = "waiting_for_tracks";
          state.pendingResume = true;
          state.waitingSince = Date.now();
        },*/
        trackReady: (state, action) => {
            if (state.pendingResume) {
                state.status = "recording";
                state.activeLabel = action.payload;
                state.pendingResume = false;
                state.waitingSince = null;
            }
        },
        clearStaleWait: (state) => {
            if (state.status === "waiting_for_tracks") {
                state.status = "idle";
                state.pendingResume = false;
                state.waitingSince = null;
            }
        },
    },
});
export const { 
/*startRecording,
stopRecording,
beginViewSwitch,*/
trackReady, clearStaleWait, } = recordingSlice.actions;
export default recordingSlice.reducer;
